import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  useLoadScript,
} from "@react-google-maps/api";
import { SendCommunicationToProviders, getUsageCoverageDetailsAction } from "../../../../redux/actions/NetworkIntelligenceAction";
import { getSnackbarSuccess } from "../../../../Utils/helper";

export const MapView = ({searchFilter}) => {
  const [activeMarker, setActiveMarker] = useState(null);
  const dispatch = useDispatch()
  const [data, setData] = useState(null);
  const [image, setImage] = useState(null);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyAy9gYbxqSCIe2BFo46GcNAk81zP-t7ZGA", // Add your API key
  });
  // useEffect(()=>{
  //    dispatch(
  //     getUsageCoverageDetailsAction(
  //       {
  //         ...searchFilter,
  //         page: 1,
  //         rows: 200,
  //         providerIds: searchFilter?.providerIds?.toString(),
  //       },
  //       "loading"
  //     )
  //   );
  // },[])

  const getUsageCoverageDetails = useSelector(
    (state) => state?.NetworkIntelligenceReducer?.getUsageCoverageDetails
  );

  const getUsageCoverageDcPicImages = useSelector(
    (state) => state?.NetworkIntelligenceReducer?.getUsageCoverageDcPicImages
  );

  const filterImage = (id) => {
    const images = getUsageCoverageDcPicImages.filter((ele) => {
      if (ele?.providerId === id) {
        return setImage(ele);
      }
    });
  };

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  const handleOnLoad = (map) => {
    const bounds = new window.google.maps.LatLngBounds();
    getUsageCoverageDetails.forEach((ele) => {
      bounds.extend({
        lat: Number(ele?.providerLatitude),
        lng: Number(ele?.providerLongitude),
      });
    });
    map.fitBounds(bounds);
  };

  return isLoaded ? (
    <GoogleMap
      onLoad={handleOnLoad}
      onClick={() => setActiveMarker(null)}
      // zoom={searchFilter?.pincodeOrCity === "" ? 8 : 18}
      mapContainerStyle={{ width: "100%", height: "700px" }}
    >
      {getUsageCoverageDetails?.map((ele) => (
        <Marker
          key={+ele?.providerId}
          position={{
            lat: ele?.providerLatitude,
            lng: ele?.providerLongitude,
          }}
          onClick={() => {
            handleActiveMarker(ele?.providerId);
            filterImage(ele?.providerId);
          }}
        >
          {activeMarker === ele?.providerId ? (
            <InfoWindow onCloseClick={() => setActiveMarker(null)}>
              <div>
                <div className="modalHospitalCard">
                  <div className="modalHospitalImage">
                    <img src={image?.imageUrl} alt="logo" />
                  </div>
                  <div className="d-flex modalHosptalHeader ">
                    <div className="modalHosptalLogo">
                      <img src={ele?.providerLogo} alt="logo" />
                    </div>
                    <div className="modalHospitalLabName ms-2">
                      <p>{ele?.providerName}</p>
                      <p>{ele?.providerCity}</p>
                    </div>
                  </div>
                  <div className="modalHosptalBreakTag"></div>
                  <div className="d-flex flex-wrap gap-1 ms-2 mt-2">
                    <div className="modalHosptalTotalApp p-2 mb-2">
                      <p>Appointments</p>
                      <h3>{ele?.appointmentCount}</h3>
                    </div>
                    <div className="modalHosptalTotalApp p-2 mb-2">
                      <p>Information</p>
                      <h3>{ele?.informationScorePercent}%</h3>
                    </div>
                    <div className="modalHosptalTotalApp p-2 mb-2">
                      <p>SKU & Packages</p>
                      <h3>{ele?.skuPackageScorePercent}%</h3>
                    </div>
                  </div>
                  <div className="d-flex gap-3 ms-2">
                    <p className="modalHosptalSocialMedia">
                      <span>
                        <i class="fa-brands fa-whatsapp"></i>
                      </span>{" "}
                      Whatsapp
                    </p>
                    <p className="modalHosptalSocialMedia">
                      <spna>
                        <i class="fa-sharp fa-regular fa-envelope"></i>
                      </spna>{" "}
                      {""} Gmail
                    </p>
                  </div>
                </div>
              </div>
            </InfoWindow>
          ) : null}
        </Marker>
      ))}
    </GoogleMap>
  ) : (
    ""
  );
};

export const SendEmailWhatsappToProvider = ({
  sendType,
  multiSelect,
  setPayload,
  payload,
  searchFilter,
}) => {
  const dispatch = useDispatch();
  const ref = useRef();
  const handleSubmit = async () => {
    const res = await dispatch(
      SendCommunicationToProviders({
        ...searchFilter,
        communicationType:
          sendType === "WhatsApp to Provider" ? "WhatsApp" : "Email",
        communicationSubType: payload,
        providerIds: multiSelect.toString(),
        presetFilter: "Communication",
      })
    );
    if (res?.data?.status === true) {
      let res1 = res?.data?.results?.messageOrEmail?.totalSendMessageOrEmail;
      let res2 =
        res.data.results.messageOrEmail.mobileOrEmailNotAvailable !== null
          ? res?.data?.results?.messageOrEmail?.mobileOrEmailNotAvailable
          : "";
      getSnackbarSuccess(
        "success",
        res1 + " " + res2,
        dispatch,
        10000
      );
      ref.current.click();
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  };
  return (
    <div
      className="modal fade "
      
      id="SendEmailWhatsappToProvider"
      data-bs-backdrop="false"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered __customDialog " >
        <div className="modal-content" >
          <div className="modal-header  mb-3" style={{backgroundColor:"#e7e7f2"}}>
            <h4 style={{ fontWeight: "500" }}>{sendType}</h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={ref}
              onClick={() => {
                setPayload("");
                // setReason("");
              }}
            ></button>
          </div>
          <div>
            <div className="mb-2" style={{ padding: "15px" }}>
              <select
                className="form-select "
                value={payload}
                onChange={(e) => setPayload(e.target.value)}
              >
                <option value=""> Select Type </option>
                <option value="UpdateLogo">Update Logo</option>
                <option value="UpdateSkuPackage">
                  {" "}
                  Update SKU Information
                </option>
                <option value="UpdateProfie">Update Profile</option>
              </select>
            </div>
          </div>
          <div className="modal-footer justify-content-end d-flex ">
            <div >
              <button
                type="button"
                className="approve-btn"
                onClick={() => handleSubmit()}
                disabled={payload === "" ? true : false}
              >
                Send
              </button>
              <button
                 className="reject-btn"
                aria-label="Close"
                type="button"
                data-bs-dismiss="modal"
                id="closeAppointment"
                ref={ref}
                onClick={() => setPayload("")}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const initialStateCoverage = {
  page: 1,
  rows: 10,
  providerIds: "",
  visitSupport: "",
  pincodeOrCity: "",
  startDate: moment().subtract(15, "days").format("YYYY-MM-DD"),
  endDate: moment(new Date()).format("YYYY-MM-DD"),
  sortDirection: "desc",
  serviceIds: "",
  specialityIds: "",
  ProviderStatusIds: "",
  SortColumn: "AppointmentCount",
  distanceInKms: 0,
  clients: [],
  BusinessType: "CBU",
  ibuServices: [],
  providerClassIds: "",
  providerCertificateCodes: "",
  qualificationIds: "",
  experienceIds: "",
  providerCategoryIds: "",
  dcLogo: null,
  gmb: null,
  doctorPhoto: null,
  centrePhoto: null,
  IsDoctorSlot:null,
  state:"",
  city:"",
  maxNPS:100,
  minNPS:0
};

export const placeholderSelectColor = {
  placeholder: (provided, state) => ({
    ...provided,
    color: "black",
  }),
};
